import { EpDevPPluginIds } from "../constants";

export class EpDevPApiFactories {
  
  public static rootRoute(): string { return EpDevPPluginIds.EpDevPPluginId; }

}

